import { render, staticRenderFns } from "./userDismoney.vue?vue&type=template&id=6adf3844&scoped=true&"
import script from "./userDismoney.vue?vue&type=script&lang=js&"
export * from "./userDismoney.vue?vue&type=script&lang=js&"
import style0 from "./userDismoney.vue?vue&type=style&index=0&id=6adf3844&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf3844",
  null
  
)

export default component.exports